import * as React from 'react';

import { Input } from '../../../Shared';

const note = (
  <section className="note">
    <h2>A note about creating your own lessons on Quill</h2>
    <p>You can build your own lesson by creating a customized edition of a Quill Lesson. However, you cannot yet create a new lesson from scratch.</p>
    <a className="quill-button small outlined green focus-on-light" href="https://support.quill.org/using-quill-tools/quill-lessons/how-do-i-customize-a-quill-lesson" rel="noopener noreferrer" target="_blank">Learn More</a>
  </section>
)

export default class CustomizeEditionHeader extends React.Component<any, any> {
  render() {
    const { editionName, lessonNumber, lessonTitle, sampleQuestion, updateName, updateSampleQuestion, clearName, clearSampleQuestion, nameError, timesSubmitted, } = this.props
    return (
      <div className="customize-edition-header-container">
        <div className='customize-edition-header'>
          <section className="lesson-title-section">
            <p>You are creating an edition of this lesson:</p>
            <h1><span>Lesson {lessonNumber}:</span>{lessonTitle}</h1>
          </section>
          <section className="edition-fields-card">
            <Input
              className="bordered large"
              error={nameError}
              handleCancel={clearName}
              handleChange={updateName}
              id="edition-name"
              label="Edition Name"
              placeholder="Enter a name for this edition"
              timesSubmitted={timesSubmitted}
              value={editionName || ''}
            />
            <Input
              className="bordered large"
              handleCancel={clearSampleQuestion}
              handleChange={updateSampleQuestion}
              id="edition-sample-question"
              label="Sample Question"
              placeholder="Enter a sample question for this edition"
              value={sampleQuestion || ''}
            />
          </section>
          {note}
        </div>
      </div>
    )

  }
}
